import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";
import { handleRetriveError } from "../utils";

interface shippingMethodState {
    results: any[];
}


const initialState: shippingMethodState = {
    results: [],
};


const shippingMethodSlice = createSlice({
    name: "shippingMethod",
    initialState,
    reducers: {
        setShippingMethod(state, action) {
            state.results = action.payload;
        },
    },
});

export const { setShippingMethod } = shippingMethodSlice.actions;

export const fetchShippingMethod = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response:any = await api.getShippingMethods();
        dispatch(setShippingMethod(response.results));
    } catch (error) {
        handleRetriveError(error);
    }
};

export default shippingMethodSlice.reducer;
